import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import styled from 'styled-components'
import { topics } from './services/faq.service'
import { connect } from 'react-redux'
import { Accordion } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { PRIMARY_COLOR, GRAY } from '../../styles/colors.style'

const StyledFaq = styled.div`
	display: flex;
	padding: 3rem 0 4.6rem;
	justify-content: center;

	.ui.styled.accordion,
	.ui.styled.accordion .accordion {
		box-shadow: none;
		width: 100%;
	}

	.ui.styled.accordion .title {
		border-bottom: 1px solid ${PRIMARY_COLOR};
		border-top: 0;
		color: ${GRAY};
		display: flex;
		font-size: 1.8rem;
		font-weight: 500;
		justify-content: flex-start;
		padding-left: 0;
	}

	.ui.styled.accordion .active.title {
		color: ${PRIMARY_COLOR};
		font-size: 1.8rem;
	}

	.ui.accordion .active.content {
		padding-left: 2em;
	}
`

class FaqPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			faqTopics: [],
		}
		this.getFaqTopics()
	}

	componentDidMount() {
		const { hideLoading } = this.props
		hideLoading()
	}

	render() {
		const faqTopics = this.state.faqTopics
		return (
			<Container>
				<Title>
					<span className="bold">Perguntas</span> Frequentes
				</Title>
				<StyledFaq>
					<Accordion
						defaultActiveIndex={0}
						panels={this.rootPanels(faqTopics)}
						styled
					/>
				</StyledFaq>
			</Container>
		)
	}

	faqContent = (faqItems) => {
		let items = faqItems.map((faq, key) => {
			return {
				key: key,
				title: faq.question,
				content: ReactHtmlParser(faq.answer),
			}
		})

		return (
			<div>
				<Accordion.Accordion panels={items} />
			</div>
		)
	}

	childContent = (childItems) => {
		let items = childItems.map((child, key) => {
			if (child.faqItems.length > 0) {
				return {
					key: key,
					title: child.title,
					content: { content: this.faqContent(child.faqItems) },
				}
			}

			if (child.childs.length > 0)
				return {
					key: key,
					title: child.title,
					content: { content: this.childContent(child.childs) },
				}
		})

		return (
			<div>
				<Accordion.Accordion panels={items} />
			</div>
		)
	}

	rootPanels = (faq = []) => {
		let items = faq.map((topic, key) => {
			if (topic.childs.length > 0)
				return {
					key: key,
					title: topic.title,
					content: { content: this.childContent(topic.childs) },
				}

			if (topic.faqItems.length > 0)
				return {
					key: key,
					title: topic.title,
					content: { content: this.faqContent(topic.faqItems) },
				}
		})

		return items
	}

	getFaqTopics() {
		topics()
			.then(({ data: response }) => {
				if (response.success) {
					this.setState({ faqTopics: response.data })
				}
			})
			.catch(({ response }) => {})
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading,
		},
		dispatch
	)

const connectedFaqPageComponent = withRouter(
	connect(null, mapDispatchToProps)(FaqPage)
)

export { connectedFaqPageComponent as ModuleRootComponent }
